import React from "react";
import Unauthorized from "../pages/Unauthorized";
import Loader from "../components/loader";
import Layout from "../components/layout";
import Header from "../components/header";

interface PermissionProps {
  value: any[] | null; // direct array of permissions or null for loading
  check: "R" | "W" | "D"; // which permission to check
  children: React.ReactNode;
  page?: boolean; // for READ (R) and WRITE (W) page-level checks
}

const Permission: React.FC<PermissionProps> = ({
  value,
  check,
  children,
  page,
}) => {
  // Show loading state when value is null
  if (value === null) {
    if ((check === "R" || check === "W") && page) {
      return (
        <div className="flex-grow h-screen flex items-center justify-center">
          <Loader />
        </div>
      );
    }
    return null;
  }

  // If not an array (but not null), return null
  if (!Array.isArray(value)) return null;

  // Find matching permission by keyCode
  const perm = value.find((p) => p.keyCode === check);
  const hasPermission = perm?.permission === true;

  // READ permission → show page or Unauthorized
  if (check === "R") {
    if (hasPermission) return <>{children}</>;
    return <Unauthorized />;
  }

  // WRITE with page flag → show page or Unauthorized
  if (check === "W" && page) {
    if (hasPermission) return <>{children}</>;
    return <Unauthorized />;
  }

  // WRITE or DELETE (inline) → return children if allowed, else null
  if (check === "W" || check === "D") {
    return hasPermission ? <>{children}</> : null;
  }

  return null;
};

export const hasPermission = (value: any[] | null, check: "R" | "W" | "D"): boolean => {
  if (!Array.isArray(value)) return false;
  return value.find((p) => p.keyCode === check)?.permission === true;
};

export default Permission;
